import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { SimpleRouterState } from '@platform-frontend/util';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountRouteService } from '../account-router/account-route.service';
import { GotoSignInNavigationExtras } from './model/goto-sign-in-navigation-extras';
import { GotoSignIn } from './session.actions';
import { SessionState } from './session.state';

export const SignedInGuard: CanActivateChildFn | CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const accountRouteService = inject(AccountRouteService);
  if (!store.selectSnapshot(SessionState.isSignedIn) && store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    const activateWithoutSession = route.data.activateWithoutSession ?? false;
    const navExtras: GotoSignInNavigationExtras = accountRouteService.extendAccountNavigationExtras<GotoSignInNavigationExtras>(
      state.url,
      route.paramMap,
      route.queryParamMap,
      {
        signInMode: 'AUTO',
        autostartPage: true
      }
    );
    return store.dispatch(new GotoSignIn(navExtras)).pipe(map(() => activateWithoutSession));
  } else {
    return of(true);
  }
};
